import { render, staticRenderFns } from "./NoticeDetailsView.vue?vue&type=template&id=4829ef7e&"
import script from "./NoticeDetailsView.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailsView.vue?vue&type=style&index=0&id=4829ef7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports